module.exports = __webpack_public_path__ + "media/icons/smart-sales-c65d0717.svg";